import { useEvent, useUnit } from 'effector-react';
import { setLastOpenedWorkspaceId } from '@nx-frontend/shared/api';
import { setWorkspacesEvent } from '@nx-frontend/shared/store/current-workspace';
import { searchValueChanged, reinitSearchEvent } from '@nx-frontend/shared/store/search';
import { setSidebarFetchMenuTreeEvent, setSidebarIsLoadedEvent } from '@nx-frontend/shared/store/sidebar';
import { fetchWorkspaceTagsEvent } from '@nx-frontend/shared/store/tags';
import { $user } from '@nx-frontend/shared/store/user';
import { updateWorkspaceAccessEvent } from '@nx-frontend/shared/store/workspace-access';
import { $workspaces } from '@nx-frontend/shared/store/workspaces';

export function useChangeWorkspace() {
  const [workspaces, user] = useUnit([$workspaces, $user]);
  const [
    setCurrentWorkspace,
    updateWorkspaceAccess,
    setSearchValue,
    reinitSearch,
    setSidebarFetchMenuTree,
    setSidebarIsLoaded,
  ] = useUnit([
    setWorkspacesEvent,
    updateWorkspaceAccessEvent,
    searchValueChanged,
    reinitSearchEvent,
    setSidebarFetchMenuTreeEvent,
    setSidebarIsLoadedEvent,
  ]);
  const fetchWorkspaceTags = useEvent(fetchWorkspaceTagsEvent);

  return (workspaceId: string) => {
    const selectedWorkspace = workspaces.find((workspace) => workspace.globalId === workspaceId);
    if (selectedWorkspace) {
      setCurrentWorkspace(selectedWorkspace);
      updateWorkspaceAccess({ workspaceId });
    }
    setSearchValue('');
    reinitSearch();

    if (user.id && selectedWorkspace && workspaces) {
      setLastOpenedWorkspaceId({
        userId: user.id,
        orgId: selectedWorkspace.orgId,
        workspaceId: selectedWorkspace.globalId,
      });
    }
    setSidebarFetchMenuTree(true);
    fetchWorkspaceTags({ workspaceId });
    setSidebarIsLoaded(false);
  };
}
